export const WHAT_IS_AN_ESIM_TRIGGER = 'data-target*="what-is-an-esim"';
export const WHAT_IS_AN_EID_TRIGGER = 'data-target*="what-is-an-eid"';
